import { render } from "./CutBucketHat_6_back.vue?vue&type=template&id=4863aa5b"
import script from "./CutBucketHat_6_back.vue?vue&type=script&lang=js"
export * from "./CutBucketHat_6_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__